<app-dialog [config]="data.config" (actionButtonClicked)="dialogRef.close()">
        <ng-container dialog-title>
            {{ data.title }}
        </ng-container>
</app-dialog>
